import type { Styles } from "@chakra-ui/theme-tools";
import { PX_BASE } from "./design-tokens/PX_BASE";

export const globalStyles: Styles = {
    global: {
        ":root": {
            // This is just a fallback value which matches chrome desktop.
            // The actual width of the scrollbar is calculated and set in the variable from the <SetScrollbarWidth /> component.
            "--scrollbar-width": "15px",
        },
        body: {
            color: "black",
            bg: "white",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base",
            height: "100%",
            fontSize: PX_BASE,
        },
        // This is the same Chakra uses to lock body scroll.
        // Unfortunately they dynamically load the style so we can't use it ourselves by adding the property to the body.
        // Chakra also doesn't expose any utility to lock the body scroll, it's all done internally.
        "body[data-scroll-locked]": {
            overflow: "hidden !important",
            overscrollBehavior: "contain",
            position: "relative !important",
            paddingLeft: "0px",
            paddingTop: "0px",
            paddingRight: "0px",
            marginLeft: "0px",
            marginTop: "0px",
            marginRight: "var(--scrollbar-width, 15px)",
        },
        "*::placeholder": {
            color: "gray.400",
        },
        "*, *::before, &::after": {
            borderColor: "gray.200",
            wordWrap: "break-word",
        },
        // We need this styles to overwrite the user style agent for safari, otherwise in the animations we will have margins.
        "h2, p": {
            marginBlockStart: 0,
            marginBlockEnd: 0,
            marginInlineStart: 0,
            marginInlineEnd: 0,
        },
        ".grecaptcha-badge": {
            visibility: "hidden",
            opacity: 0,
            height: "0 !important",
        },
        // Styles for printable/PDF version
        "@media print": {
            /* We need to hide usp banner, nav and footer from the PDF version, due legal requirements */
            "#navigation, #footer": {
                display: "none",
            },
            '[data-testid="USPBanner"]': {
                display: "none !important",
            },
            "#card-generic": {
                display: "none",
            },
            // Accordions need to be open when is printable version, if we don't pass important the values will be overwritten by styles on the component level
            ".chakra-collapse": {
                display: "block !important",
                height: "100% !important",
                opacity: "1 !important",
            },
        },

        'input[type="search" i]:enabled:read-write:-webkit-any(:focus, :hover)::-webkit-search-cancel-button':
            {
                opacity: 0,
            },
    },
};
